"use client";

import { AnimatePresence, motion } from "motion/react";
import { useTranslation } from "react-i18next";

import { getDateStringLocale } from "@/i18n/getDateFnsLocale.ts";

interface CalendarDayHeadersProps {
  weekDays: Date[];
  shownDays: number;
}

export function CalendarDayHeaders({ weekDays, shownDays }: CalendarDayHeadersProps) {
  const { i18n } = useTranslation();

  return (
    <div
      className="bg-background grid h-(--calendar-header-height) max-h-(--calendar-header-height) overflow-hidden"
      style={{
        gridTemplateColumns: `repeat(${shownDays}, 1fr)`,
        gridTemplateRows: `var(--calendar-header-height) 1fr`,
      }}
    >
      <AnimatePresence initial={true} mode="popLayout">
        {weekDays.slice(0, shownDays).map((day, index) => (
          <motion.div
            key={`${day.getTime()}-${index}`}
            animate={{ y: 0, opacity: 1 }}
            className={"h-full"}
            exit={{ y: 100, opacity: 0 }}
            initial={{ y: -200, opacity: 0 }}
            transition={{
              duration: 0.5,
              delay: index * 0.07,
              exit: { duration: 0.2 },
            }}
          >
            <div
              className={`text-muted-foreground relative z-10 flex h-full flex-col items-center justify-center rounded-md`}
            >
              <div className="font-medium capitalize">
                {/* Use custom day name if available (for template days) */}
                {(day as any).dayName ||
                  day.toLocaleDateString(getDateStringLocale(i18n.language), {
                    weekday: "long",
                  })}
              </div>
              <div className={`text-accent-foreground! z-30 text-xl font-bold`}>
                {/* Use short name or day number */}
                {(day as any).shortName || day.getDate()}
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
